import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import Cookies from "universal-cookie";
import md5 from 'js-md5'

const dirWebApp = process.env.REACT_APP_DIR_PRO

export const getAuth = createAsyncThunk(
    'auth/getAuth',
    async (configObj, { rejectWithValue }) => {

        const urlSchooApi = process.env.REACT_APP_URL_API  // para pruebas
        // const urlSchooApi = process.env.REACT_APP_URL_API_PRO  // para producción

        const config = configObj.config
        const rememberUser = configObj.rememberUser

        let user = config.payload
        let countPerfiles = 0
        let Carnet = ''
        let Fotov = ''

        if (config.method === 'GET') {
            config.params = config.payload
        }
        else if (config.method === 'POST') {
            config.data = config.payload
        }

        try {

            const response = await Axios(config)
            // const paths = response.data.Menu.map(x => {return {path: x.Ruta, access: x.Acceso, name: x.Nombre}})
            const paths = response.data.Menu.map(x => {
                return {
                    path: x.Ruta === '/#' ? '#' : x.Ruta, access: x.Acceso, name: x.Nombre, icono: x.Icono, component: x.Componente, pathcomponente: x.RutaComponente, solvente: x.Solvente,
                    submen: x.Ruta === '/#' ? x.SubMenu.map(xx => {
                        return { path: `${xx.Ruta === "/reporte_morosidad" ? "/reporte_descuento_reducido" : xx.Ruta}`, access: xx.Acceso, name: xx.Nombre, icono: xx.Icono, component: xx.Componente, pathcomponente: xx.RutaComponente }
                    }) : ''
                }
            })

            if (response?.data?.IdEmp?.length === 7) {
                const configPerfiles = {
                    method: "GET",
                    url: `${urlSchooApi}/perfilalumno/perfilesfamilia`,
                    headers: configObj.config.headers,
                    params: { IdFamilia: response.data.IdEmp },
                }

                const resPerfiles = await Axios(configPerfiles)
                countPerfiles = resPerfiles.data.msg.length
                console.log(resPerfiles)

                Carnet = resPerfiles.data.msg[0].Carnet
                Fotov = resPerfiles.data.msg[0].fotov
                user = JSON.stringify({ LoginId: resPerfiles.data.msg[0].nombre, password: md5(JSON.parse(user).password) })
            }

            user = JSON.stringify({ LoginId: JSON.parse(user).LoginId, password: JSON.parse(user).password })
            console.log(user)
            const { Bodega: bodegas, IdEmp, IdSede, IdSemestre, pathDefault } = response.data
            return { paths, user, rememberUser, IdEmp, bodegas, IdSede, IdSemestre, pathDefault, countPerfiles, Carnet, Fotov }
        }
        catch (err) {
            console.log('errorrr:  ', err)
            return// rejectWithValue(err.response.data.msg)
        }
    }
)

const setInitialState = () => {

    const cookies = new Cookies()

    const checked = JSON.parse(localStorage.getItem('rememberUser'))

    let booleanLoggedIn
    const StrLoggedIn = cookies.get('loggedIn')
    if (StrLoggedIn === 'true') {
        booleanLoggedIn = true
    } else {
        booleanLoggedIn = false
    }

    if (checked) {
        return (
            {
                pathDefault: JSON.parse(localStorage.getItem('pathDefault')),
                inactivity: JSON.parse(localStorage.getItem('inactivity')),
                IdSemestre: JSON.parse(localStorage.getItem('IdSemestre')),
                loggedIn: JSON.parse(localStorage.getItem('loggedIn')),
                bodegas: JSON.parse(localStorage.getItem('bodegas')),
                IdSede: JSON.parse(localStorage.getItem('IdSede')),
                Carnet: JSON.parse(localStorage.getItem('Carnet')),
                Fotov: JSON.parse(localStorage.getItem('Fotov')),
                IdEmp: JSON.parse(localStorage.getItem('IdEmp')),
                paths: JSON.parse(localStorage.getItem('paths')),
                user: JSON.parse(localStorage.getItem('user')),
                rememberUser: checked,
                error: null,
            }
        )
    } else {
        return (
            {
                //paths: cookies.get('paths'),//JSON.parse(sessionStorage.getItem('paths')),
                inactivity: JSON.parse(localStorage.getItem('inactivity')),
                paths: JSON.parse(localStorage.getItem('paths')),
                pathDefault: cookies.get('pathDefault'),
                IdSemestre: cookies.get('IdSemestre'),
                bodegas: cookies.get('bodegas'),
                IdSede: cookies.get('IdSede'),
                Carnet: cookies.get('Carnet'),
                Fotov: cookies.get('Fotov'),
                IdEmp: cookies.get('IdEmp'),//JSON.parse(sessionStorage.getItem('IdEmp')),
                user: cookies.get('user'),//JSON.parse(sessionStorage.getItem('user')),
                loggedIn: booleanLoggedIn,
                rememberUser: false,
                error: null
            }
        )
    }
}

const authSlice = createSlice({
    name: 'auth',
    initialState: setInitialState(),
    reducers: {
        logout: (state) => {

            const cookies = new Cookies()

            state.user = ''
            state.loggedIn = false
            state.IdEmp = ''
            state.paths = ''
            state.pathDefault = ''
            state.bodegas = ''
            state.IdSede = ''
            state.IdSemestre = ''
            state.Carnet = ''
            state.Fotov = ''

            if (state.rememberUser) {
                localStorage.setItem('pathDefault', JSON.stringify(state.pathDefault))
                localStorage.setItem('IdSemestre', JSON.stringify(state.IdSemestre))
                localStorage.setItem('loggedIn', JSON.stringify(state.loggedIn))
                localStorage.setItem('bodegas', JSON.stringify(state.bodegas))
                localStorage.setItem('IdSede', JSON.stringify(state.IdSede))
                localStorage.setItem('Carnet', JSON.stringify(state.Carnet))
                localStorage.setItem('Fotov', JSON.stringify(state.Fotov))
                localStorage.setItem('paths', JSON.stringify(state.paths))
                localStorage.setItem('IdEmp', JSON.stringify(state.IdEmp))
                localStorage.setItem('user', JSON.stringify(state.user))
            } else {
                cookies.set('loggedIn', JSON.stringify(state.loggedIn), { path: dirWebApp })
                cookies.set('IdEmp', JSON.stringify(state.IdEmp), { path: dirWebApp })//sessionStorage.setItem('IdEmp', JSON.stringify(state.IdEmp))                
                cookies.set('user', JSON.stringify(state.user), { path: dirWebApp })//sessionStorage.setItem('user', JSON.stringify(state.user))
                //cookies.set('paths', JSON.stringify(state.paths), { path: dirWebApp })//sessionStorage.setItem('paths', JSON.stringify(state.paths))
                localStorage.setItem('paths', JSON.stringify(state.paths))
                cookies.set('pathDefault', JSON.stringify(state.pathDefault), { path: dirWebApp })
                cookies.set('IdSemestre', JSON.stringify(state.IdSemestre), { path: dirWebApp })
                cookies.set('bodegas', JSON.stringify(state.bodegas), { path: dirWebApp })
                cookies.set('IdSede', JSON.stringify(state.IdSede), { path: dirWebApp })
                cookies.set('Carnet', JSON.stringify(state.Carnet), { path: dirWebApp })
                cookies.set('Fotov', JSON.stringify(state.Fotov), { path: dirWebApp })
            }

            //state.loggedIn = false
            //localStorage.setItem('loggedIn', JSON.stringify(state.loggedIn))

            state.rememberUser = false
            localStorage.setItem('rememberUser', JSON.stringify(state.rememberUser))

            state.inactivity = false
            localStorage.setItem('inactivity', JSON.stringify(state.inactivity))

            localStorage.removeItem('paths')
            localStorage.removeItem('showModalDeuda')
            window.location.replace(dirWebApp + 'login')
        },
        autoLogout: (state) => {

            const cookies = new Cookies()

            state.user = ''
            state.loggedIn = false
            state.IdEmp = ''
            state.paths = ''
            state.pathDefault = ''
            state.bodegas = ''
            state.IdSede = ''
            state.IdSemestre = ''
            state.Carnet = ''
            state.Fotov = ''

            if (state.rememberUser) {
                localStorage.setItem('pathDefault', JSON.stringify(state.pathDefault))
                localStorage.setItem('IdSemestre', JSON.stringify(state.IdSemestre))
                localStorage.setItem('loggedIn', JSON.stringify(state.loggedIn))
                localStorage.setItem('bodegas', JSON.stringify(state.bodegas))
                localStorage.setItem('IdSede', JSON.stringify(state.IdSede))
                localStorage.setItem('Carnet', JSON.stringify(state.Carnet))
                localStorage.setItem('Fotov', JSON.stringify(state.Fotov))
                localStorage.setItem('IdEmp', JSON.stringify(state.IdEmp))
                localStorage.setItem('paths', JSON.stringify(state.paths))
                localStorage.setItem('user', JSON.stringify(state.user))
            } else {
                cookies.set('loggedIn', JSON.stringify(state.loggedIn), { path: dirWebApp })
                cookies.set('IdEmp', JSON.stringify(state.IdEmp), { path: dirWebApp })//sessionStorage.setItem('IdEmp', JSON.stringify(state.IdEmp))
                cookies.set('user', JSON.stringify(state.user), { path: dirWebApp })//sessionStorage.setItem('user', JSON.stringify(state.user))
                //cookies.set('paths', JSON.stringify(state.paths), { path: dirWebApp })//sessionStorage.setItem('paths', JSON.stringify(state.paths))
                localStorage.setItem('paths', JSON.stringify(state.paths))
                cookies.set('pathDefault', JSON.stringify(state.pathDefault), { path: dirWebApp })
                cookies.set('IdSemestre', JSON.stringify(state.IdSemestre), { path: dirWebApp })
                cookies.set('bodegas', JSON.stringify(state.bodegas), { path: dirWebApp })
                cookies.set('IdSede', JSON.stringify(state.IdSede), { path: dirWebApp })
                cookies.set('Carnet', JSON.stringify(state.Carnet), { path: dirWebApp })
                cookies.set('Fotov', JSON.stringify(state.Fotov), { path: dirWebApp })
            }

            //state.loggedIn = false
            //localStorage.setItem('loggedIn', JSON.stringify(state.loggedIn))

            state.rememberUser = false
            localStorage.setItem('rememberUser', JSON.stringify(state.rememberUser))

            state.inactivity = true
            localStorage.setItem('inactivity', JSON.stringify(state.inactivity))

            window.location.replace(dirWebApp + 'login')
        },
        perfilcarnet: (state, action) => {
            const cookies = new Cookies()
            state.Carnet = action.payload.Carnet
            state.Fotov = action.payload.Fotov
            state.user = JSON.stringify({ LoginId: action.payload.user, password: md5(JSON.parse(state.user).password) })

            if (state.rememberUser) {
                localStorage.setItem('Carnet', JSON.stringify(state.Carnet))
                localStorage.setItem('Fotov', JSON.stringify(state.Fotov))
                localStorage.setItem('user', JSON.stringify(state.user))
            } else {
                cookies.set('Carnet', JSON.stringify(state.Carnet), { path: dirWebApp })
                cookies.set('Fotov', JSON.stringify(state.Fotov), { path: dirWebApp })
                cookies.set('user', JSON.stringify(state.user), { path: dirWebApp })
            }
            
            window.location.replace(dirWebApp)
        },
    },
    extraReducers: {
        [getAuth.pending]: (state, action) => {
            state.error = null
        },
        [getAuth.fulfilled]: (state, action) => {

            const cookies = new Cookies()
            state.user = action.payload.user
            state.loggedIn = true
            state.rememberUser = action.payload.rememberUser
            state.IdSemestre = action.payload.IdSemestre
            state.pathDefault = action.payload.pathDefault
            state.bodegas = action.payload.bodegas
            state.IdSede = action.payload.IdSede
            state.Carnet = action.payload.Carnet
            state.Fotov = action.payload.Fotov
            state.IdEmp = action.payload.IdEmp
            state.paths = action.payload.paths

            if (state.rememberUser) {
                localStorage.setItem('rememberUser', JSON.stringify(state.rememberUser))
                localStorage.setItem('pathDefault', JSON.stringify(state.pathDefault))
                localStorage.setItem('IdSemestre', JSON.stringify(state.IdSemestre))
                localStorage.setItem('loggedIn', JSON.stringify(state.loggedIn))
                localStorage.setItem('bodegas', JSON.stringify(state.bodegas))
                localStorage.setItem('IdSede', JSON.stringify(state.IdSede))
                localStorage.setItem('Carnet', JSON.stringify(state.Carnet))
                localStorage.setItem('Fotov', JSON.stringify(state.Fotov))
                localStorage.setItem('IdEmp', JSON.stringify(state.IdEmp))
                localStorage.setItem('paths', JSON.stringify(state.paths))
                localStorage.setItem('user', JSON.stringify(state.user))
            } else {
                cookies.set('rememberUser', JSON.stringify(state.rememberUser, { path: dirWebApp }))//sessionStorage.setItem('rememberUser', JSON.stringify(state.rememberUser))
                cookies.set('loggedIn', JSON.stringify(state.loggedIn), { path: dirWebApp })
                cookies.set('IdEmp', JSON.stringify(state.IdEmp), { path: dirWebApp })//sessionStorage.setItem('IdEmp', JSON.stringify(state.IdEmp))
                cookies.set('user', JSON.stringify(state.user), { path: dirWebApp })//sessionStorage.setItem('user', JSON.stringify(state.user))
                //cookies.set('paths', JSON.stringify(state.paths), { path: dirWebApp })//sessionStorage.setItem('paths', JSON.stringify(state.paths))
                localStorage.setItem('paths', JSON.stringify(state.paths))
                cookies.set('pathDefault', JSON.stringify(state.pathDefault), { path: dirWebApp })
                cookies.set('IdSemestre', JSON.stringify(state.IdSemestre), { path: dirWebApp })
                cookies.set('bodegas', JSON.stringify(state.bodegas), { path: dirWebApp })
                cookies.set('IdSede', JSON.stringify(state.IdSede), { path: dirWebApp })
                cookies.set('Carnet', JSON.stringify(state.Carnet), { path: dirWebApp })
                cookies.set('Fotov', JSON.stringify(state.Fotov), { path: dirWebApp })
            }
            
            //state.loggedIn = true
            //localStorage.setItem('loggedIn', JSON.stringify(state.loggedIn))

            state.inactivity = false
            localStorage.setItem('inactivity', JSON.stringify(state.inactivity))
            //http://localhost:3000/campus/admisiones
            if (action.payload.countPerfiles > 1) {
                
                window.location.replace(dirWebApp + 'perfiles')
            } else {
                if(window.location.pathname === "/campus/centro" ){
                    window.location.href = dirWebApp + "centro"
                }
                if(window.location.pathname === "/campus/admisiones" ){
                    window.location.href = dirWebApp + "admisiones"
                  }
                // si es centro u admisiones, recargar, de lo contrario no
            }
        },
        [getAuth.rejected]: (state, action) => {

            const cookies = new Cookies()

            state.user = ''
            cookies.set('user', JSON.stringify(state.user), { path: dirWebApp })//sessionStorage.setItem('user', JSON.stringify(state.user))
            state.loggedIn = false
            cookies.set('loggedIn', JSON.stringify(state.loggedIn), { path: dirWebApp })
            state.IdEmp = ''
            state.rememberUser = false
            cookies.set('rememberUser', JSON.stringify(state.rememberUser, { path: dirWebApp }))//sessionStorage.setItem('rememberUser', JSON.stringify(state.rememberUser))
            cookies.set('IdEmp', JSON.stringify(state.IdEmp), { path: dirWebApp })//sessionStorage.setItem('IdEmp', JSON.stringify(state.IdEmp))
            state.paths = ''
            cookies.set('paths', JSON.stringify(state.paths), { path: dirWebApp })//sessionStorage.setItem('paths', JSON.stringify(state.paths))
            state.bodegas = ''
            cookies.set('bodegas', JSON.stringify(state.bodegas), { path: dirWebApp })
            state.pathDefault = ''
            cookies.set('pathDefault', JSON.stringify(state.pathDefault), { path: dirWebApp })
            state.IdSemestre = ''
            cookies.set('IdSemestre', JSON.stringify(state.IdSemestre), { path: dirWebApp })
            state.IdSede = ''
            cookies.set('IdSede', JSON.stringify(state.IdSede), { path: dirWebApp })
            state.Carnet = ''
            cookies.set('Carnet', JSON.stringify(state.Carnet), { path: dirWebApp })
            state.Fotov = ''
            cookies.set('Fotov', JSON.stringify(state.Fotov), { path: dirWebApp })
            state.error = action.payload

            //state.loggedIn = false
            //localStorage.setItem('loggedIn', JSON.stringify(state.loggedIn))

            state.inactivity = false
            localStorage.setItem('inactivity', JSON.stringify(state.inactivity))
        }

    },
})

export const { logout, autoLogout, perfilcarnet } = authSlice.actions

export default authSlice.reducer